export const CONTACT_ROLES = {
  sender: "sender", // Sender is a user who can send treats to the recipients in workspace
  member: "member", // Member is a user who can receive treats from the senders in workspace
  owner: "owner", // Owner is a user who is the owner of the workspace
  owners: "owners", // Owner is a user who is the owner of the workspace
  nonMember: "non_member", // Non-member is a user who is not a member of the workspace like some lead or prospect
  admin: "admin", // Admin is a user who can manage the workspace and its settings
  admins: "admins", // Admin is a user who can manage the workspace and its settings
};

export const ROLES_LABELS = {
  admin: "Admin",
  member: "Member",
  sender: "Sender",
  non_member: "Non-Member",
  owner: "Owner",
  stadium_expert: "Stadium Expert",
};

export const NON_MEMBER_ROLE_LABEL = "Non-Member";

export const { sender, member, owner, owners, nonMember, admin, admins } = CONTACT_ROLES;

export const ROLES_WITH_ADMIN_CAPABILITIES = [owners, owner, admin, admins];
export const ROLES_WITH_SENDER_CAPABILITIES = [owner, admin, sender];
export const ROLES_WITHIN_WORKSPACE = [owner, admin, sender, member];
export const ALL_POSSIBLE_ROLES = [owner, admin, sender, member, nonMember];

export const ROLES_OPTIONS = [
  {
    label: "Admin",
    value: admin,
    name: admin,
    subHeading: "Admins have configurable share/edit access to the platform.",
  },
  {
    label: "Sender",
    value: sender,
    name: sender,
    subHeading: "Senders can create and manage their own resources.",
  },
  {
    label: "Member",
    value: member,
    name: member,
    subHeading:
      "Members can receive gifts, send points and items through shops when enabled, and use quick recognize.",
  },
  {
    label: "Non-Member",
    value: nonMember,
    name: nonMember,
    subHeading:
      "Non-Members can only see the company Feed and the shops that are shared with them.",
  },
];

export const CUSTOM_PERMISSION = "Custom";
export const DEFAULT_PERMISSION = "Default";

export const CONTACT_PERMISSIONS_OPTIONS = [DEFAULT_PERMISSION, CUSTOM_PERMISSION];
export const DEFAULT_FIELD = "---";

export const PERMISSION_SUB_HEADINGS = {
  [DEFAULT_PERMISSION]: "Default admin can create and manage their own resources.",
};
